import {Fragment, useState, useEffect} from 'react'

import Api from '../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import {useAuth} from '../core/Auth'
import {AuthModel} from '../core/_models'
import {useNavigate} from 'react-router-dom'

const api = new Api()

export function BackdoorLogin() {
  const [formData, setFormData] = useState({})
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const {saveAuth, setCurrentUser} = useAuth()

  const handleInput = (e: any, name: any) => {
    setFormData({...formData, [name]: e.target.value})
  }

  const handleSubmit = () => {
    setLoading(true)
    api
      .loginBackdoor(formData)
      .then((response: any) => {
        setLoading(false)

        const {data} = response.data

        if (data?.role_name != 'Alumni') {
          toast.error('Email atau Password tidak sesuai.')
          return
        }

        localStorage.setItem('apiToken', data.token)
        
        // Transform data to match AuthModel structure
        const authData: AuthModel = {
          api_token: data.token,
          refreshToken: data.refreshToken,
        }
        saveAuth(authData)
        setCurrentUser(data)

        if (data?.role_name) {
          localStorage.setItem('role', 'Alumni')
        }

        navigate('/dashboard', {replace: true})
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        toast?.error(data?.meta?.message)
      })
  }

  return (
    <div>
      <form>
        <label htmlFor='email'>Email</label>
        <input type='text' name='email' onChange={(value) => handleInput(value, 'email')} />

        <label htmlFor='pin'>Pin</label>
        <input type='password' name='pin' onChange={(value) => handleInput(value, 'pin')} />

        <button type='button' disabled={loading} onClick={handleSubmit}>
          {loading ? 'Loading...' : 'Login'}
        </button>
      </form>
    </div>
  )
}
